import PropTypes from 'prop-types'
import React from 'react'

const ShowHide = ({ show, children }) =>
  show ? <div>{children}</div> : <noscript />

ShowHide.displayName = 'ShowHide'

ShowHide.propTypes = {
  children: PropTypes.any,
  show: PropTypes.any
}

export default ShowHide



// WEBPACK FOOTER //
// ./ui/ShowHide.js